import { FunctionComponent } from 'react'

import { Icon, IIconProps } from 'native-base'
import { Path } from 'react-native-svg'

type Props = IIconProps & { size?: number }

export const AlertIcon68: FunctionComponent<Props> = ({ size, ...props }) => {
  const originalWidth = 20.0

  const originalHeight = 16.0

  const maxDim = Math.max(originalWidth, originalHeight)

  const scale = size ? size / maxDim : 1

  const width = originalWidth * scale

  const height = originalHeight * scale

  return (
    <Icon viewBox="0 0 20 16" width={width} height={height} {...props}>
      <Path
        d="M13.5 0C13.776 0 14 0.224 14 0.5V3H19.5C19.777 3 20 3.224 20 3.5V12.98C20 14.648 18.649 16 16.98 16H3.019C1.351 16 0 14.648 0 12.98V3.5C0 3.224 0.224 3 0.5 3H6V0.5C6 0.255 6.177 0.0499956 6.41 0.00799561L6.5 0H13.5ZM19 9.22498C18.465 9.70698 17.757 10 16.98 10H12V11.5C12 11.745 11.823 11.95 11.59 11.992L11.5 12H8.5C8.224 12 8 11.776 8 11.5V10H3.02C2.244 10 1.53601 9.70801 1.00101 9.22601L1 12.98C1 14.096 1.904 15 3.019 15H16.98C18.096 15 19 14.096 19 12.98V9.22498ZM11 8H9V11H11V8ZM19 4H1V6.98099C1 8.09599 1.904 9 3.02 9H8V7.5C8 7.255 8.177 7.05 8.41 7.008L8.5 7H11.5C11.776 7 12 7.224 12 7.5V9H16.98C18.045 9 18.917 8.17701 18.994 7.13101L19 6.98099V4ZM13 1H7V3H13V1Z"
        fill="#404040"
      />
    </Icon>
  )
}
